import { manifestController } from 'magner';
import { PROJECT_NAME } from '~/constants';

const manifest = manifestController({
  name: PROJECT_NAME,
  short_name: PROJECT_NAME,
});

export default manifest;
